import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IonAlert, IonToast } from '@ionic/react';
import { isDefined } from '../../lib/utils';
import { removeToast } from '../../store/actions';
import { withTranslation } from '../../lib/translate';
import { getConfig } from '../../appConfig.js';

class Toast extends Component {
  constructor(props) {
    super(props);

  }

  showToast = () => {
    const { message, toastType, __, removeToast } = this.props;
    return (
      <IonAlert
        isOpen={true}
        onDidDismiss={() => {
          removeToast(); // removes original toast
          removeToast(); // removes separator toast (empty one)
        }}
        message={__(message)}
        buttons={[
          {
            text: __('Close'),
            role: 'cancel',
            cssClass: 'primary'
          },
        ]}
      >

      </IonAlert>

    );
  };

  render() {
    const { message, __ } = this.props;

    return isDefined(message) && message !== '' ? this.showToast() : null;
  }
}

const stateToProps = (state) => {
  const { common } = state;
  let message = '';
  let toastType = 'warning';

  if (common && common.toast && common.toast.length > 0) {
    message = common.toast[0].message;
    toastType = common.toast[0].toastType;
  }

  return {
    message,
    toastType,
    isConnectedToNetwork: common.isConnectedToNetwork,
  };
};

const dispatchToProps = (dispatch) => {
  return {
    removeToast: () => dispatch(removeToast()),
  };
};

export default connect(stateToProps, dispatchToProps)(withTranslation(Toast));
